'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StorageWrapper = require('./StorageWrapper');

var _StorageWrapper2 = _interopRequireDefault(_StorageWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _StorageWrapper2.default(localStorage);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvdXRpbHMvbG9jYWxTdG9yYWdlV3JhcHBlci5qc3giXSwibmFtZXMiOlsiU3RvcmFnZVdyYXBwZXIiLCJsb2NhbFN0b3JhZ2UiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBOzs7Ozs7a0JBRWUsSUFBSUEsd0JBQUosQ0FBbUJDLFlBQW5CLEMiLCJmaWxlIjoibG9jYWxTdG9yYWdlV3JhcHBlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBTdG9yYWdlV3JhcHBlciBmcm9tICcuL1N0b3JhZ2VXcmFwcGVyJztcblxuZXhwb3J0IGRlZmF1bHQgbmV3IFN0b3JhZ2VXcmFwcGVyKGxvY2FsU3RvcmFnZSk7XG4iXX0=